/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualRevision: core.serialization.ObjectSchema<
    serializers.NotEqualRevision.Raw,
    Truvity.NotEqualRevision
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace NotEqualRevision {
    export interface Raw {
        value: number;
    }
}
